import React, { useState } from "react";
import { TextField, Button, Alert, Stack, Link as MuiLink } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import ClientPortalShell from "./ClientPortalShell";
import { portalForgotPassword } from "../../api/clientPortal";
import { getClientPortalErrorMessage } from "./clientPortalErrorMessage";

export default function ClientPortalForgotPasswordPage() {
  const [params] = useSearchParams();
  const company = String(params.get("company") || "").trim().toLowerCase();
  const q = company ? `?company=${encodeURIComponent(company)}` : "";

  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await portalForgotPassword({ email: email.trim(), company });
      setOk(true);
    } catch (err) {
      setError(getClientPortalErrorMessage(err, { context: "forgotPassword" }));
    } finally {
      setBusy(false);
    }
  };

  return (
    <ClientPortalShell title="Recuperar senha" subtitle="Enviaremos um link para seu e-mail">
      {ok ? (
        <Alert severity="success">
          Se existir cadastro liberado, enviaremos instruções por e-mail.
        </Alert>
      ) : (
        <Stack component="form" spacing={2} onSubmit={handleSubmit}>
          <TextField
            label="E-mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
          />
          {error && <Alert severity="error">{error}</Alert>}
          <Button type="submit" variant="contained" disabled={busy}>
            {busy ? "Enviando…" : "Enviar link"}
          </Button>
        </Stack>
      )}
      <MuiLink component={Link} to={`/portal-cliente${q}`} variant="body2" sx={{ display: "block", mt: 2, textAlign: "center" }}>
        Voltar ao login
      </MuiLink>
    </ClientPortalShell>
  );
}
